import { render } from "./NotFound.vue?vue&type=template&id=45e07e82&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=45e07e82&lang=css"
import "./NotFound.vue?vue&type=style&index=1&id=45e07e82&scoped=true&lang=scss"

import exportComponent from "/pxplus_official_website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e07e82"]])

export default __exports__